import { useContext } from 'react';

import type { CmsRendering } from '@eneco/cms-adapter';

import { RenderingContext } from './rendering-context';

/**
 * Returns the children of a named placeholder on the current rendering.
 *
 * The legacy `@eneco/sitecore-common.usePlaceholder` exposed scope-aware
 * placeholder fetching for runtime personalization. That feature stays in
 * the legacy lib until Phase E moves it into the adapter contract — for
 * Phase A this hook just resolves children of the current rendering.
 */
export const usePlaceholder = (name: string): CmsRendering[] => {
  const rendering = useContext(RenderingContext);
  return rendering?.placeholders?.[name] ?? [];
};
